/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Review_And_PublishInputs */

const en_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review & Publish`)
};

const es_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar y Publicar`)
};

const fr_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier et Publier`)
};

const de_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfen & Veröffentlichen`)
};

const ja_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認して公開`)
};

const zh_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核并发布`)
};

const ar_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعة ونشر`)
};

const id_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau & Terbitkan`)
};

const it_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi & Pubblica`)
};

const ru_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверить и опубликовать`)
};

const pt_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar e Publicar`)
};

const ko_review_and_publish = /** @type {(inputs: Review_And_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검토 및 게시`)
};

/**
* | output |
* | --- |
* | "Review & Publish" |
*
* @param {Review_And_PublishInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const review_and_publish = /** @type {((inputs?: Review_And_PublishInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_And_PublishInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_review_and_publish(inputs)
	if (locale === "es") return es_review_and_publish(inputs)
	if (locale === "fr") return fr_review_and_publish(inputs)
	if (locale === "de") return de_review_and_publish(inputs)
	if (locale === "ja") return ja_review_and_publish(inputs)
	if (locale === "zh") return zh_review_and_publish(inputs)
	if (locale === "ar") return ar_review_and_publish(inputs)
	if (locale === "id") return id_review_and_publish(inputs)
	if (locale === "it") return it_review_and_publish(inputs)
	if (locale === "ru") return ru_review_and_publish(inputs)
	if (locale === "pt") return pt_review_and_publish(inputs)
	return ko_review_and_publish(inputs)
});